// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-ozg-input-element',
    emits: ["command"],
    // #endregion
    // #region Properties
    props: {
        schema: {
            type: Object,
            required: false,
            default: undefined,
        },
        content: {
            type: Object,
            required: false,
            default: undefined,
        },
        data: {
            type: Object,
            required: false,
            default: undefined,
        },
    },
    computed: {
        caption() {
            if (!this.element) {
                return null;
            }
            if (this.element.isOptional) {
                return this.element.label + ' (Optional)';
            }
            else {
                return this.element.label;
            }
        },
        element() {
            return this.content?.element;
        },
    },
    // #endregion
    // #region Core
    methods: {
        onMultiAdd() {
            this.$emit("command", "field-add", { element: this.content });
        },
        onMultiRemove(field) {
            this.$emit("command", "field-remove", { element: this.content, field: field });
        },
        onValueChanged(field) {
            this.$emit("command", "field-validate", { element: this.content, field: field });
        }
    }
    // #endregion
});
// #endregion
